import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { NetworkException } from "../utils/exceptions";
import ActionButton, { type ActionStyleType } from "./action-button";
import ButtonsGroup from "./buttons-group";
import Panel from "./panel";

export default function PanelError(props: {
  error?: Error;
  acknowledged?: () => void;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  let errorMessage = "";
  let closable = true;

  let severity = "danger";
  if (props.error) {
    if (props.error instanceof NetworkException) {
      severity = props.error.severity;
      if (props.error.code == 401) {
        if (!location.pathname.startsWith("/login")) {
          return <Navigate to={`/login/${location.pathname}`} />;
        }
      }

      if (props.error.code == 404) {
        errorMessage = "The element you are looking for was not found.";
        closable = false;
      } else {
        errorMessage = props.error.message;
      }
    } else if (props.error instanceof TypeError) {
      errorMessage = `Network error. Please check your connection and try again. \n${props.error.message}`;
    } else {
      errorMessage = props.error.message;
    }
  }

  if (errorMessage.length == 0) {
    errorMessage = "An error occurred while processing your request.";
  }

  return (
    <Panel
      fixed
      header="Request error"
      headerStyle={(() => {
        switch (severity) {
          case "danger":
            return "Error" as ActionStyleType;
          case "warning":
            return "Warning" as ActionStyleType;
          case "info":
            return "Info" as ActionStyleType;
          case "success":
            return "Success" as ActionStyleType;
          default:
            return "Error" as ActionStyleType;
        }
      })()}
    >
      {errorMessage}
      <ButtonsGroup>
        {closable && <ActionButton action="Close" onOk={props.acknowledged} />}
        <ActionButton
          action="Home"
          onOk={() => {
            navigate("/home");
            props.acknowledged?.();
          }}
        />
      </ButtonsGroup>
    </Panel>
  );
}
